import { getAdvisees, doCsvUploadForAdviseeAdvisors, requestAccessToPlanningStream, getAllCalendarEvents,
  getCalendarEventsForParticipants, createOrUpdateCalendarEvent, getAdviseeDetail,reProcessEnrollmet, 
  deleteCalendarEvent, getPersonProfilesForSelectedUsers, getNamedQueries, getPersonTags, unenrollUserFromProgram,
  getAdviseesPersonTags, getAllAdviseesMinInfo, overrideCourse, getFutureCalendarEventsForParticipant,manualRelease,getExportNamedQueriesToCsv,manualWaive } from '../api'

export const loadAdvisees = ({ state, commit }, {name, sort}) => {
  let page = state.page
  let count = state.count
  return getAdvisees(page, count, name, sort).then(data => {
    commit('LOAD_ADVISEES', data.advisees)
    commit('LOAD_TOTAL', data.total)
    commit('LOAD_PAGE', data.page)
    commit('LOAD_COUNT', data.count)
    return data
  })
}
export const loadAllAdviseesMinInfo = ({ state, commit }, {name, page, count,sort}) => {
  return getAllAdviseesMinInfo(page, count, name, sort).then(data => {
    return data
  })
}
export const loadUpdatePageCount = ({ state, commit }, {page, count}) => {
  commit('LOAD_PAGE', page)
  commit('LOAD_COUNT', count)
}

export const uploadAdviseeAdvisorCsvFile = ({ state, commit }, {institutionId, createdByUuid, fileData}) => {
  return doCsvUploadForAdviseeAdvisors(institutionId, createdByUuid, fileData).then(res => {
    return res
  })
}

export const loadRequestAccessToPlanningStream = ({ state, commit }, userId) => {
  return requestAccessToPlanningStream(userId)
}

export const loadSaveCalendarEvent = ({ state, commit }, data) => {
  return createOrUpdateCalendarEvent(data)
}

export const loadAllCalendarEvents = ({ state, commit }) => {
  return getAllCalendarEvents()
}

export const loadNamedQueries = ({ state, commit }) => {
  return getNamedQueries()
}
export const loadExportNamedQueriesToCsv = ({ state, commit }, {queryId, tags}) => {
  return getExportNamedQueriesToCsv(queryId, tags)
}
export const loadPersonTags = ({ state, commit }, userId) => {
  return getPersonTags(userId)
}

export const loadAdviseesPersonTags = ({ state, commit }) => {
  return getAdviseesPersonTags()
}
export const releaseCourse = ({ state, commit }, {uuid, status}) => {
  return manualRelease(uuid, status)
}
export const waiveCourse = ({ state, commit }, {uuid, details, score, status}) => {
  return manualWaive(uuid, details, score, status)
}
export const overrideCourseScore = ({ state, commit }, {uuid, score}) => {
  return overrideCourse(uuid, score)
}
export const unenrollFromProgram = ({ state, commit }, {userId, programCode}) => {
  return unenrollUserFromProgram(userId, programCode)
}

export const reProcessProgramEnrollment = ({ state, commit }, {userId, programCode}) => {
  return reProcessEnrollmet(userId, programCode)
}

export const loadCalendarEventsForParticipants = ({ state, commit }, userUuids) => {
  return getCalendarEventsForParticipants(userUuids)
}

export const loadFutureCalendarEventsForParticipant = ({ state, commit }, participantId) => {
  return getFutureCalendarEventsForParticipant(participantId)
}

export const loadDeleteCalendarEvent = ({ state, commit }, uuid) => {
  return deleteCalendarEvent(uuid)
}

export const loadPersonProfilesForSelectedUsers = ({ state, commit }, uuids) => {
  return getPersonProfilesForSelectedUsers(uuids)
}

export const loadAdviseeDetail = ({ state, commit }, uuid) => {
  return getAdviseeDetail(uuid)
}



// WEBPACK FOOTER //
// ./src/app/adviseeTracker/vuex/actions.js